'use client';

import dynamic from 'next/dynamic';

// Next adds every client component that a server module imports, with or without `dynamic()`,
// to the route's entry, and rendering any one of them loads the whole entry. Only `dynamic()` in
// a client module gives each component a chunk that loads when the page renders it.

export const AccordionMenu = dynamic(() => import('./AccordionMenu'));
export const ActonSubmitButton = dynamic(() => import('./ActonSubmitButton'));
export const BroadlumeLogo = dynamic(() => import('./BroadlumeLogo'));
export const DatePickerInput = dynamic(() => import('./DatePicker'));
export const FaderCarousel = dynamic(() => import('./FaderCarousel'));
export const FeaturedProducts = dynamic(
  () =>
    import('@dealerportal/catalog-ui/Modules/FeaturedProducts/FeaturedProducts')
);
export const FormNotes = dynamic(() => import('./FormNotes'));
export const Gallery = dynamic(() => import('./Gallery'));
export const GoogleMap = dynamic(() => import('./GoogleMap'));
export const Masonrygallery = dynamic(() => import('./MasonryGallery'));
export const Navigation = dynamic(() => import('./Navigation'));
export const PrintCouponButton = dynamic(() => import('./PrintCouponButton'));
export const ProductSearchBox = dynamic(() => import('./ProductSearchBox'));
export const RecentProducts = dynamic(() => import('./RecentProducts'));
export const SourceInput = dynamic(() => import('./SourceInput'));
export const SwiperLink = dynamic(() => import('./SwiperLink'));
export const TabComponent = dynamic(() => import('./TabComponent'));
